// this is an autogenerated file from DesignSystem/CheckOutAction/mutation-requirements-check.graphql
import { gql } from 'Data/Api'

export default gql`
mutation app__DesignSystem_CheckOutAction($id: uuid!, $params: jsonb) {
  create_pre_appointment_bookings_state_update_automations(
    appointment_booking_id: $id
    state: "CHECKED_OUT"
    params: $params
  ) {
    event_execution_ids
    is_pending
  }
}

`